export function INIT(state) {
	state.init = true;
}

export function SET_ENABLED(state, enabled) {
	state.enabled = enabled;
}

export function SET_AUTOREPLY(state, autoreply) {
	state.autoreply = autoreply;
}

export function SET_NAME(state, name) {
	state.name = name;
}

export function SET_OPEN_HOURS(state, openHours) {
	state.openHours = openHours;
}

export function SET_QUESTIONS(state, questions) {
	state.questions = questions;
}

export function UPDATE_QUESTIONS(state, questions) {
	Object.assign(state.questions, questions);
}
